export const backendUrl = process.env.REACT_APP_BACKEND_URL;
export const domain = process.env.REACT_APP_DOMAIN || "";
export const clientId = process.env.REACT_APP_CLIENT_ID || "";
export const publicKey = process.env.REACT_APP_PUBLIC_KEY || "";
export const VERSION = "5.0.0";
export const PrivacyPolicy = "https://sites.google.com/view/quran-app-z";
